import {Component, EventEmitter, inject, Input, OnInit, Output, signal, WritableSignal, ChangeDetectionStrategy} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {animate, style, transition, trigger} from '@angular/animations';
import {Challenge} from '@/app/core/models/p-place/pixel';
import {ChallengeService} from '@services/p-place/challenge.service';
import {ChallengeCardComponent} from '@components/challenge-card/challenge-card.component';

@Component({
	selector: 'peps-place-challenge',
	imports: [
		TranslatePipe,
		ChallengeCardComponent
	],
	templateUrl: './challenge.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	animations: [
		trigger('fadeInOut', [
			transition(':enter', [
				style({ opacity: 0 }),
				animate('300ms ease-out', style({ opacity: 1 }))
			]),
			transition(':leave', [
				animate('300ms ease-in', style({ opacity: 0 }))
			])
		]),
		trigger('scaleInOut', [
			transition(':enter', [
				style({ transform: 'scale(0.8)' }),
				animate('300ms ease-out', style({ transform: 'scale(1)' }))
			]),
			transition(':leave', [
				animate('300ms ease-in', style({ transform: 'scale(0.8)' }))
			])
		])
	]
})
export class ChallengeComponent implements OnInit {

	private readonly challengeService = inject(ChallengeService);

	protected challenges: WritableSignal<Challenge[]> = signal([]);

	@Output() close = new EventEmitter<void>();
	@Input() challengesUserCompleted: Challenge[] = [];

	ngOnInit() {
		this.loadChallenges();
	}

	private loadChallenges() {
		this.challengeService.getChallenges().subscribe({
			next: challenges => {
				this.challenges.set(challenges);
			}
		})
	}

	protected onBackgroundClick(event: Event) {
		if (event.target === event.currentTarget) {
			this.closeChallengeModal();
		}
	}

	protected closeChallengeModal() {
		this.close.emit();
	}

	protected isChallengeCompleted(challenge: Challenge): boolean {
		return this.challengesUserCompleted.some(c => c.id === challenge.id);
	}
}
